<template>
  <div>
    FOOTER
  </div>
</template>
<script>
export default {
  name: 'casinoFooter',
  props: [],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/CasinoFooter.vue